module.exports = __webpack_public_path__ + "img/sms_outlined.5319ddeb.svg";